import { PORTAL_API_BASE_URL } from '../../../../constants';
import request from '../../../../util/APIUtils';

const BASE = `${PORTAL_API_BASE_URL}/api/admin/lms/completion-rule-migration`;

const req = (opts) => request({ ...opts, throw400Error: true });

/**
 * Load full migration status + report for a linked course (View dialog).
 * @param {number|string} resourceId
 */
export const getMigrationStatus = async (resourceId) =>
  req({
    url: `${BASE}/resources/${encodeURIComponent(resourceId)}`,
    method: 'GET',
  });

/**
 * Retry a failed/deferred migration (no-op when already migrated).
 * @param {number|string} resourceId
 * @param {{orgUnitId?: string}} [options]
 */
export const retryMigration = async (resourceId, { orgUnitId } = {}) => {
  const body =
    orgUnitId != null && String(orgUnitId).trim() !== ''
      ? JSON.stringify({ orgUnitId: String(orgUnitId).trim() })
      : undefined;
  return req({
    url: `${BASE}/resources/${encodeURIComponent(resourceId)}/retry`,
    method: 'POST',
    ...(body ? { body } : {}),
  });
};

/**
 * Resolve a needs-review rule item.
 * @param {number|string} resourceId
 * @param {string} ruleId
 * @param {{note?: string}} [options]
 */
export const resolveReviewItem = async (resourceId, ruleId, { note } = {}) =>
  req({
    url: `${BASE}/resources/${encodeURIComponent(resourceId)}/review-items/${encodeURIComponent(ruleId)}/resolve`,
    method: 'POST',
    body: JSON.stringify(note ? { note } : {}),
  });

/**
 * Dismiss a needs-review rule item.
 * @param {number|string} resourceId
 * @param {string} ruleId
 * @param {{note?: string}} [options]
 */
export const dismissReviewItem = async (resourceId, ruleId, { note } = {}) =>
  req({
    url: `${BASE}/resources/${encodeURIComponent(resourceId)}/review-items/${encodeURIComponent(ruleId)}/dismiss`,
    method: 'POST',
    body: JSON.stringify(note ? { note } : {}),
  });
